import { createApp } from "vue";
// import App from "./App.vue";
import App from "./App.vue";
// @ts-ignore
import router from "@/router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { wujie } from "@/utils/wujie";
import "./global.scss";
import "@/style/global/main.scss";
import GxDialog from "./components/GxUIComponents/GxDialog/GxDialog.vue";

const app = createApp(App);

app.component("gx-dialog", GxDialog);

console.log("window.wujie.props", window.$wujie?.props);
app.use(router);
app.use(wujie);
app.use(ElementPlus);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) app.component(key, component);
app.mount("#app");
